import { createListenerMiddleware, ListenerEffectAPI } from '@reduxjs/toolkit'
import { AggregateState, finishActivityWorkflowAsync } from '@/store/slices/aggregateSlice'
import { objectiveWorkflowApi } from '../api/objectiveWorkflowApi'

export const activityFinishListenerMiddleware = createListenerMiddleware()

activityFinishListenerMiddleware.startListening({
  actionCreator: finishActivityWorkflowAsync.fulfilled,
  effect: (action, listenerApi: ListenerEffectAPI<any, any>) => {
    const dispatch = listenerApi.dispatch
    const aggregate: AggregateState = listenerApi.getState().aggregate
    const objectiveWorkflowId = aggregate.current?.lastObjectiveWorkflow?.id

    if (!objectiveWorkflowId) return

    dispatch(
      objectiveWorkflowApi.endpoints.fetchActivityWorkflowAggregateFullTree.initiate(
        { objectiveWorkflowId },
        /**
         * It should be true instead of 1, otherwise after finishing the activity, it will not be re-fetched.
         */
        { forceRefetch: true },
      ),
    )
  },
})
